export default __webpack_public_path__ + "static/media/calendar.36e28671.svg";